import { FormattedMessage } from 'react-intl';

const LearnMorePage = () => {
  return (
    <div>
      <h1>
        <FormattedMessage defaultMessage='Learn More' />
      </h1>
    </div>
  );
};

export default LearnMorePage;
